class CheeseMap {
    constructor(container) {
        if (!container) {
            console.error('Container element is required to initialize CheeseMap');
            return
        }
        this.container = container;

        this.image = this.container.querySelector('[data-cheese-map-image]');

        this.markers = this.container.querySelectorAll('[data-cheese-map-marker]');

        this.modal = document.querySelector('[data-cheese-map-modal]');
        if (!this.modal) {
            console.error('Modal element is required to initialize CheeseMap');
            return;
        }
        this.modalTitle = this.modal.querySelector('[data-cheese-map-modal-title]');
        this.modalText = this.modal.querySelector('[data-cheese-map-modal-text]');
        this.modalLink = this.modal.querySelector('[data-cheese-map-modal-link]');
        this.modalLinkText = this.modal.querySelector('[data-cheese-map-modal-link-text]');
        this.modalClose = this.modal.querySelector('[data-cheese-map-modal-close]');

        if (!this.modalTitle || !this.modalText || !this.modalLink) {
            console.error('Modal title, text and link elements are required to initialize CheeseMap');
            return;
        }

        // Optional logging of click positions if user logged in (for simpler marker positioning)
        this.doLog = this.container.dataset.loggerOn !== undefined;
    }
    init() {
        this.markers.forEach(marker => {
            marker.addEventListener('click', () => {
                // Toggle modal if already open for this marker
                if (this.modal.classList.contains('active') && this.modal.parentElement === marker) {
                    this.hideModal();
                    return;
                }
                this.showModal(marker, 'active');
                this.scrollToMarker(marker);
            });
            marker.addEventListener('mouseenter', () => {
                // reset state if hovering another marker while modal is open
                if (this.modal.parentElement !== marker) {
                    this.hideModal();
                }
                this.showModal(marker, 'hover')
            });
            marker.addEventListener('mouseleave', () => this.leaveModal());
        });

        this.modal.addEventListener('click', (e) => {
            if (e.target === this.modal) {
                this.hideModal();
            }
        });

        document.addEventListener('click', (e) => {
            const isClickInsideModal = this.modal.contains(e.target);
            const isClickOnArea = Array.from(this.markers).some(area => area.contains(e.target));

            if (!isClickInsideModal && !isClickOnArea && this.modal.classList.contains('active')) {
                this.hideModal();
            }
        });

        this.modalClose.addEventListener('click', (e) => {
            e.stopPropagation(); // Prevent click from bubbling to modal
            this.hideModal()
        });

        // set initial position
        if (window.innerWidth < 768 && this.markers && this.markers.length > 0) {
            this.scrollToMarker(this.markers[0], 0.1);
        }

        // only on small screens are the container scrolls
        this.container.addEventListener('scrollend', (e) => {
            console.log('Container scrolled', e);
        });

        // Optional logging of click positions for easier marker placement
        if (this.doLog) {
            this.container.addEventListener('click', (e) => {
                const containerRect = this.container.getBoundingClientRect();
                const clickX = e.clientX - containerRect.left;
                const clickY = e.clientY - containerRect.top;
                const percentX = (clickX / containerRect.width * 100).toFixed(2);
                const percentY = (clickY / containerRect.height * 100).toFixed(2);

                console.log(`Click position: X=${percentX}, Y=${percentY}`);
            });
        }
    }

    showModal(marker, className = 'active') {

        const link = marker.dataset.link || '#';
        const title = marker.dataset.title;
        const text = marker.dataset.text;
        const linkText = marker.dataset.linkText || 'Mehr erfahren';

        this.modalTitle.textContent = title;
        this.modalText.textContent = text;
        this.modalLinkText.textContent = linkText;
        this.modalLink.href = link;

        this.modal.classList.add(className);

        marker.classList.add('active');
        marker.appendChild(this.modal); // Move modal to marker for positioning & events
    }

    scrollToMarker(marker, offsetY = 0.8) {

        if (window.innerWidth > 768) {
            // Center marker in viewport
            const markerRect = marker.getBoundingClientRect();
            const markerCenterY = markerRect.top + window.scrollY + (markerRect.height / 2);
            const viewportCenterY = window.innerHeight / 2;
            const scrollToY = markerCenterY - viewportCenterY;

            window.scrollTo({
                top: scrollToY,
                behavior: 'smooth'
            });
        } else {

            // Position of the marker relative to the image (scrollable content)
            const containerRect = this.container.getBoundingClientRect();
            const markerRect = marker.getBoundingClientRect();

            // Absolute position of the marker within this.container's scroll space
            const markerAbsLeft = markerRect.left + markerRect.width * 0.5 - containerRect.left + this.container.scrollLeft;
            const markerAbsTop = markerRect.top - containerRect.top + this.container.scrollTop;

            // Target: marker should appear at 50% from the right → 50% from left
            // and at 100% * offsetY from top (e.g. 90% from top if offsetY=0.9)
            const targetX = markerAbsLeft - containerRect.width * 0.50;
            const targetY = markerAbsTop - containerRect.height * offsetY;

            this.container.scrollTo({
                left: targetX,
                top: targetY,
                behavior: 'smooth'
            });

        }
    }

    hideModal() {
        this.modal.classList.remove('active');
        this.modal.classList.remove('hover');

        this.markers.forEach(marker => {
            marker.classList.remove('active');
        });
    }

    leaveModal() {
        this.modal.classList.remove('hover');
    }
}

export default CheeseMap;
